import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DialogForm from '@/components/ui/dialogs/form-dialog';
import { useCallback, useState } from 'react';
import LocationAddForm from '@/components/forms/admin/locations/add';
import { useSnackbar } from '@/contexts/snackbar';

const LocationsPanel = () => {
  const { t } = useTranslation();

  const { showSnackbarMessage } = useSnackbar();

  const [showAddLocationForm, setShowAddLocationForm] = useState(false);

  const handleAddLocationClick = useCallback(() => {
    setShowAddLocationForm(true);
  }, []);

  const handleAddLocationCancel = useCallback(() => {
    setShowAddLocationForm(false);
  }, []);

  const onLocationAdded = useCallback(() => {
    setShowAddLocationForm(false);
    showSnackbarMessage(t('location_add_success'), 'success');
  }, [showSnackbarMessage, t]);

  const onAddLocationError = useCallback(() => {
    showSnackbarMessage(t('location_add_failure'), 'error');
  }, [showSnackbarMessage, t]);

  return (
    <Box width="100%">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <Button
          onClick={handleAddLocationClick}
          variant="contained"
          color="secondary"
          sx={{
            padding: { xs: 1, sm: 2 },
            fontSize: { xs: '16px', sm: '20px' }
          }}
        >
          {t('add_location')}
        </Button>
      </Box>
      <DialogForm
        open={showAddLocationForm}
        onSubmit={onLocationAdded}
        onCancel={handleAddLocationCancel}
        onError={onAddLocationError}
        FormComponent={LocationAddForm}
        maxHeightAllowed={'no'}
      />
    </Box>
  );
};

export default LocationsPanel;
